// test2605
(2605 && 0);
